import styled from 'styled-components';

const FullscreenSidebarFooter = styled.div``;
export default FullscreenSidebarFooter;
